import request from '../request'
import requestUrl from '../requestUrl'
import requestParam from '../requestParam'
import { serviceWithHeader } from '../request'

/**
 * 查询 queryMatterLog
 * @param {*} s
 */
export const queryMatterLog = (params) => {
    return request({
        url: requestUrl('/client/clientMatterLog/queryMatterLog'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 查询 AuditType
 * @param {*} s
 */
export const queryAuditType = (params) => {
    return request({
        url: requestUrl('/client/clientMatterLog/queryAuditType'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 查询 queryMatterLogStatus
 * @param {*} s
 */
export const queryMatterLogStatus = (params) => {
    return request({
        url: requestUrl('/client/clientMatterLog/queryMatterLogStatus'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 查询 queryMatterLogTypeDescs
 * @param {*} s
 */
export const queryMatterLogTypeDescs = (params) => {
    return request({
        url: requestUrl('/client/clientMatterLog/queryMatterLogTypeDescs'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 查询 queryMatterLogCategory
 * @param {*} s
 */
export const queryMatterLogCategory = (params) => {
    return request({
        url: requestUrl('/client/clientMatterLog/queryMatterLogCategory'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 查询 queryEntitys
 * @param {*} s
 */
export const queryEntitys = (params) => {
    return request({
        url: requestUrl('/client/clientMatterLog/queryEntitys'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 查询 searchKpmgOwner
 * @param {*} s
 */
export const searchKpmgOwner = (params) => {
    return request({
        url: requestUrl('/client/clientMatterLog/searchKpmgOwner'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 查询 searchClientOwner
 * @param {*} s
 */
export const searchClientOwner = (params) => {
    return request({
        url: requestUrl('/client/clientMatterLog/searchClientOwner'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 查询 queryMatterLogPriority
 * @param {*} s
 */
export const queryMatterLogPriority = (params) => {
    return request({
        url: requestUrl('/client/clientMatterLog/queryMatterLogPriority'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 查询 queryRelatedIssues
 * @param {*} s
 */
export const queryRelatedIssues = (params) => {
    return request({
        url: requestUrl('/client/clientMatterLog/queryRelatedIssues'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * addMatterLog
 * @param {*} s
 */
export const addMatterLog = (params) => {
    return request({
        url: requestUrl('/sys/clientMatterLog/addMatterLog'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * addMatterLog
 * @param {*} s
 */
export const deleteMatterLog = (params) => {
    return request({
        url: requestUrl('/sys/clientMatterLog/deleteMatterLog'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * clientUpdateMatterLog
 * @param {*} s
 */
export const clientUpdateMatterLog = (params) => {
    return request({
        url: requestUrl('/client/clientMatterLog/updateMatterLog'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * kpUpdateMatterLog
 * @param {*} s
 */
export const kpUpdateMatterLog = (params) => {
    return request({
        url: requestUrl('/sys/clientMatterLog/updateMatterLog'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * kpUpdateMatterLog
 * @param {*} s
 */
export const addComments = (params) => {
    return request({
        url: requestUrl('/client/clientMatterLog/addComments'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * queryComments
 * @param {*} s
 */
export const queryComments = (params) => {
    return request({
        url: requestUrl('/client/clientMatterLog/queryComments'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * queryComments
 * @param {*} s
 */
export const uploadMatterFiles = (params) => {
    return request({
        url: requestUrl('/client/clientMatterLog/uploadMatterFiles'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 封装的事项日志上传接口 begin
 */
function getError(action, option, xhr) {
    let msg
    if (xhr.response) {
        msg = `${xhr.response.error || xhr.response}`
    } else if (xhr.responseText) {
        msg = `${xhr.responseText}`
    } else {
        msg = `fail to post ${action} ${xhr.status}`
    }

    const err = new Error(msg)
    err.status = xhr.status
    err.method = 'post'
    err.url = action
    return err
}

function getBody(xhr) {
    const text = xhr.responseText || xhr.response
    if (!text) {
        return text
    }

    try {
        return JSON.parse(text)
    } catch (e) {
        return text
    }
}
export const uploadMatterLogFiles = (option) => {
    if (typeof XMLHttpRequest === 'undefined') {
        return false
    }

    const xhr = new XMLHttpRequest()
    const action = requestUrl('/client/clientMatterLog/uploadMatterFile')

    if (xhr.upload) {
        xhr.upload.onprogress = function progress(e) {
            if (e.total > 0) {
                e.percent = (e.loaded / e.total) * 100
            }
            option.onProgress && option.onProgress(e)
        }
    }

    const formData = new FormData()

    if (option.data) {
        Object.keys(option.data).forEach((key) => {
            formData.append(key, option.data[key])
        })
    }

    formData.append('file', option.file, option.file.name ? option.file.name : '')

    xhr.onerror = function error(e) {
        option.onError && option.onError(e)
    }

    xhr.onload = function onload() {
        if (xhr.status < 200 || xhr.status >= 300) {
            return option.onError && option.onError(getError(action, option, xhr))
        }

        option.onSuccess && option.onSuccess(getBody(xhr))
    }

    xhr.open('post', action, true)

    if (option.withCredentials && 'withCredentials' in xhr) {
        xhr.withCredentials = true
    }

    const headers = {
        Authorization: sessionStorage.getItem('JSESSIONID'),
        siteClassification: sessionStorage.getItem('siteClassification')
    }

    for (let item in headers) {
        if (headers.hasOwnProperty(item) && headers[item] !== null) {
            xhr.setRequestHeader(item, headers[item])
        }
    }
    xhr.send(formData)
    return xhr
}

/**
 * 封装的事项日志上传接口 end
 */

/**
 * downloadMatterFiles
 * @param {*} s
 */
export const downloadMatterFiles = (params) => {
    return request({
        url: requestUrl('/client/clientMatterLog/downloadMatterFiles'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    })
}

export const exportMatterLog = (params) => {
    return serviceWithHeader({
        url: requestUrl('/client/clientMatterLog/export'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    })
}

export const deleteComment = (params) => {
    return request({
        url: requestUrl('/client/clientMatterLog/deleteComment'),
        method: 'delete',
        data: requestParam(params)
    })
}

export const changeMatterLog = (params) => {
    return request({
        url: requestUrl('/client/clientMatterLog/changeMatterLog'),
        method: 'post',
        data: requestParam(params)
    })
}
export const queryHomePageMatterInfo = (params) => {
    return request({
        url: requestUrl('/client/clientMatterLog/queryAllHomePageMatterInfo'),
        method: 'post',
        data: requestParam(params)
    })
}
export const queryMatterInfo = (params) => {
    return request({
        url: requestUrl('/client/clientMatterLog/queryMatterInfo'),
        method: 'post',
        data: requestParam(params)
    })
}
export const deleteMatterSingleFile = (params) => {
    return request({
        url: requestUrl('/client/clientMatterLog/deleteMatterSingleFile'),
        method: 'delete',
        data: requestParam(params)
    })
}
export const queryTodayCount = (params) => {
    return request({
        url: requestUrl('/client/clientMatterLog/queryTodayCount'),
        method: 'post',
        data: requestParam(params)
    })
}
export const queryTodayCommentInfos = (params) => {
    return request({
        url: requestUrl('/client/clientMatterLog/queryTodayCommentInfos'),
        method: 'post',
        data: requestParam(params)
    })
}
